import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiConfig } from 'common/models/api-service/api-config.model';
import { Schema } from 'common/models/schema/schema.model';

const uploadFileConfig = {
    uploadFile: (
        file: FormData,
        header: any,
        additionalConfig: any,
        variant: string,
        targetId: string,
        entityType: string
    ): ApiConfig =>
        new ApiConfig(
            `Storage/upload`,
            'POST',
            `variantName=${variant}&targetId=${targetId}&entityType=${entityType}`,
            file,
            '',
            header,
            additionalConfig
        ),
    addSyncLog: (data: Schema): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.FILE_UPLOAD}/${METHOD.FILE_UPLOAD.ADD_SYNC_LOG}`,
            ApiMethods.POST,
            '',
            data
        ),
    getSyncDetails: (): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.FILE_UPLOAD}/${METHOD.FILE_UPLOAD.GET_SYNC_DETAILS}`,
            ApiMethods.GET
        ),
    fetchUploadStatus: (): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.FILE_UPLOAD}/${METHOD.FILE_UPLOAD.GET_FILE_DETAILS}`,
            ApiMethods.GET
        )
};

export default uploadFileConfig;
